export default __webpack_public_path__ + "static/quote-video-1-6c7c328818da43515e8122403fe9f5de.mp4";